<app-header></app-header>
<app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

<div class="wrapper">

    <app-estimate-box [isLoader]="isLoader" [showForward]="false" [submitBtnLabel]="'Continue'"
        (submitBtnClick)="continue()" (backClick)="back()"></app-estimate-box>

    <div class="section_wrapper" style="margin-top: 20px;">
        <!-- stepper component -->
        <div class="dashBoard addons_wrap">
            <app-stepper currentIndex="2.1" class="stepper"></app-stepper>
            <div class="addon_wrapper ">
                <h3 class="font_40_a32 addon_title">Add-Ons</h3>
                <div class=" addon_section">
                    <div>
                        <div class="addons">
                            <div class="addons_details_wrap">
                                <div>
                                    <p class="mls_title">
                                        MLS Services
                                    </p>
                                    <p class="mls_content">If you would like more MLSs, please
                                        select from the list
                                        below and add lockbox services at an additional cost.</p>
                                </div>
                                <div class="mls_service">

                                    <div *ngFor="let mls of mlsService; let i = index"
                                        [ngClass]="{selected: mls.isIncluded}" class="mls_card d_flex justify_space_bt">
                                        <div class="d_flex  align_center">
                                            <mat-checkbox [disabled]="mls.isDefault" [checked]="mls.isIncluded"
                                                color="#81B5B1" (change)="addMLS(mls)"></mat-checkbox>
                                            <p class="mls_name font_18_a32_700" style="margin-right: 16px;">{{mls.name}}
                                            </p>
                                            <p class="font_20_a32_700" *ngIf="!mls.isDefault" style="margin: 0 16px;">
                                                ${{mls.price | number}}</p>
                                            <app-green-button-v2 [styles]="{fontSize:'16px'}" class="default_btn"
                                                *ngIf="mls.isDefault" width="74px" height="24px"
                                                label="Default"></app-green-button-v2>
                                        </div>

                                        <div class="d_flex align_center lockbox" *ngIf="mls.lockbox">
                                            <p class="font_16_a32_700" style="margin-right: 10px;" *ngIf="mls.lockbox">
                                                ${{mls.lockbox.price | number}}</p>
                                            <app-switch-green [isLabelBefore]="true" [disabled]="!mls.lockbox"
                                                [checked]="mls.lockbox && mls.lockbox.isLockIncluded"
                                                label="Lockbox service"
                                                (checkedChange)="changeSwitch($event,mls)"></app-switch-green>
                                        </div>
                                    </div>
                                </div>

                                <div style="margin-top: 20px;">
                                    <p class="mls_title">
                                        Other Services
                                    </p>
                                </div>
                                <div class="addons_detail" *ngFor="let data of addonData; let i = index"
                                    [ngClass]="{selected: data.isAdded}">
                                    <div class="addon_detail_title d_flex justify_space_bt align_center">
                                        <p class="font_18_a32_700 ">{{data.name}}
                                            <span class="saveText subText">
                                                {{data.subText}}
                                            </span>
                                        </p>
                                        <!-- <mat-checkbox class="signage_checkbox" *ngIf="data.sign.length!=0"
                                            color="#81B5B1">
                                            I don't want any signage
                                        </mat-checkbox> -->
                                        <!-- ngIf="data.sign.length==0" -->
                                        <p class="price addon_price">
                                            <sup>$</sup> {{data.price | number}}
                                        </p>
                                    </div>
                                    <div class="addon_content justify_space_bt d_flex align_center">
                                        <p class="font_16_a32_500">{{data.desc}}
                                        </p>
                                        <!-- ngIf="data.sign.length==0" -->


                                        <app-outlined-green-button
                                            [styles]="{display:'flex',alignItems:'center',justifyContent:'center',color:'var(--primaryColor)'}"
                                            *ngIf="data.isAdded" width="108px" height="50px" (click)="addButton(data)"
                                            label="Added">
                                            <span class="before check_icon selected"></span>
                                        </app-outlined-green-button>
                                        <app-green-button-v2
                                            [styles]="{display:'flex',alignItems:'center',justifyContent:'center'}"
                                            *ngIf="!data.isAdded" width="108px" height="50px" (click)="addButton(data)"
                                            label="Add">
                                            <!-- <span class="before check_icon"></span> -->
                                        </app-green-button-v2>

                                        <!-- <div class="sign" *ngIf="data.sign.length!=0"></div> -->
                                    </div>
                                    <!-- <mat-radio-group *ngIf="data.sign.length!=0">
                                        <div class="radio_sign" *ngFor="let signData of data.sign;">
                                            <mat-radio-button [value]='signData.id'>
                                                {{signData.name}} </mat-radio-button>
                                            <p class="price">{{signData.price}}</p>
                                        </div>
                                    </mat-radio-group> -->
                                    <!-- <app-green-button class="button_green" *ngIf="data.sign.length!=0" width="117px"
                                        height="45px" iconSize="24px" [iconBefore]=true [showPlus]=true
                                        (clicked)="addButton()" label="ADD"></app-green-button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="selected_addons_wrap" [ngClass]="{'mobile':isAddonClosed==true }">

                        <p class="font_24_a32_600 d_flex justify_space_bt align_center">Plan
                            <button (click)="addonChange()" class="arrow_Down"><i
                                    class=" fa-solid fa-chevron-down"></i></button>
                        </p>
                        <div class="selected_addons" *ngIf="isAddonClosed==true">
                            <div class="selected_wrap_v2">
                                <div>
                                    <p class="plan_name font_18_a32_700">{{selectedPlan.name}}</p>
                                    <div class="justify_space_bt d_flex align_center">
                                        <button style="margin-top: 16px;" class="change_plan" (click)="back()"> <img
                                                src="../../../assets/icons/edit.svg" alt="edit">Change plan</button>
                                        <p class="plan_price v2_price">
                                            <sup class="doller">$</sup>{{selectedPlan.price | number}}
                                        </p>
                                    </div>
                                </div>
                                <div *ngIf="selectedMls.length > 0">
                                    <p class=" font_18_a32_700">MLS</p>
                                    <div *ngFor="let selected of selectedMls; let i = index">

                                        <div class="" style="margin-top: 16px;">
                                            <p class="plan_name  justify_space_bt d_flex align_center">
                                                <span class="d_flex align_center">
                                                    <button class="close_button" color="#81B5B1"
                                                        *ngIf="!selected.isDefault" (click)="removeMls(selected,i)">
                                                        <i class="fa-solid fa-xmark" style="color: #81b5b1;"></i>
                                                    </button>
                                                    <span class="font_16_a32_500">{{selected.name}}</span>
                                                </span>
                                                <span class="v2_price"> <sup class="doller">$</sup>{{selected.price |
                                                    number}}</span>

                                            </p>
                                            <p *ngIf="selected.lockbox && selected.lockbox.isLockIncluded">
                                                Lockbox Service Added
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="selected_addons_item" *ngIf="selectedAddons.length > 0">
                                    <p class="font_18_a32_700">Add-Ons</p>
                                    <div *ngFor="let selectedAddon of selectedAddons; let i = index">
                                        <div class="" style="margin-top: 16px;">
                                            <p class="plan_name font_16_a32_500 justify_space_bt d_flex align_center">
                                                <span class="align_center d_flex">

                                                    <button class="close_button" color="#81B5B1"
                                                        (click)="removeAddon(selectedAddon,i)"> <i
                                                            class="fa-solid fa-xmark"
                                                            style=""></i></button>
                                                    <span class="font_16_a32_500">
                                                        {{selectedAddon.name}}
                                                    </span>
                                                </span>
                                                <span class="v2_price"> <sup class="doller">$</sup>
                                                    {{selectedAddon.price | number}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="total">
                                    <div class="d_flex justify_space_bt">
                                        <p class="font_18_a32_700">Total</p>
                                        <p class="plan_price font_40_a32">
                                            <sup class="doller">$</sup>{{totalAmount | number}}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="selected_addons_item">
                                <div class="selected_plan border selected_items" style="margin-top: 5px;">
                                    <p class="plan_name font_24_a32_600">{{selectedPlan.name}}</p>

                                    <p class="font_16_a32_500">{{selectedPlan.subText}}</p>
                                    <button style="margin-top: 16px;" class="change_plan" (click)="back()"> <img
                                            src="../../../assets/icons/edit.svg" alt="edit">CHANGE PLAN</button>
                                </div>
                            </div> -->
                            <!-- <div class="selected_addons_item" *ngIf="selectedMls.length > 0">
                                <p class="font_24_a32_600">MLS SERVICE</p>
                                <div *ngFor="let selected of selectedMls; let i = index">

                                    <div class="selected_plan border selected_items" style="margin-top: 5px;">
                                        <p class="plan_name font_16_a32_500 justify_space_bt d_flex align_center">
                                            {{selected.name}}
                                            <button class="close_button" color="#81B5B1" *ngIf="!selected.isDefault"
                                                (click)="removeMls(selected,i)">
                                                <i class="fa-solid fa-xmark" style="color: #81b5b1;"></i></button>
                                        </p>
                                        <p class="plan_price font_40_a32">
                                            ${{selected.price | number}}
                                        </p>

                                        <p *ngIf="selected.lockbox && selected.lockbox.isLockIncluded">
                                            Lockbox Service Added
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="selected_addons_item" *ngIf="selectedAddons.length > 0">
                                <p class="font_24_a32_600">ADD-ONS</p>
                                <div *ngFor="let selectedAddon of selectedAddons; let i = index">
                                    <div class="selected_plan border selected_items" style="margin-top: 5px;">
                                        <p class="plan_name font_16_a32_500 justify_space_bt d_flex align_center">
                                            {{selectedAddon.name}}
                                            <button class="close_button" color="#81B5B1"
                                                (click)="removeAddon(selectedAddon,i)"> <i class="fa-solid fa-xmark"
                                                    style="color: #81b5b1;"></i></button>
                                        </p>
                                        <p class="plan_price font_40_a32">
                                            ${{selectedAddon.price | number}}
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <!-- <div class="total">
                            <p class="font_24_a32_600">Total</p>
                            <div class="selected_plan border selected_items" style="margin-top: 5px;">
                                <p class="plan_price font_40_a32">
                                    ${{totalAmount | number}}*
                                </p>
                            </div>
                        </div> -->
                    </div>

                </div>

                <!-- <div class="submit_buttons">
                    <p class="save_text" *ngIf="historyState.totalAmount && historyState.from != 'plans'">
                        <span class="check_icon_save"><img src="../../../assets/icons/check_green.svg"
                                alt="done"></span>
                        Saved
                    </p>
                    <div class="buttons">
                        <button class="back_button" (click)="back()">Back</button>
                    
                        <app-green-button-v2 label="Continue" *ngIf="!isLoader" [width]="'166px'" [height]="'60px'"
                            (click)=continue()>
                            <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white"
                                style="margin-left: 10px;">
                        </app-green-button-v2>
                        <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
                    </div>
                </div> -->

                <div class="mobile_submitButtons">
                    <button class="arrowBtn leftArrow" (click)="back()">
                        <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
                    </button>
                    <app-green-button-v2 class="SumbitBtnRes" (click)="continue()" label="Continue"
                        [buttonType]="'submit'" [width]="'136px'" [height]="'50px'">
                    </app-green-button-v2>
                    <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
                    <!-- <button (click)="continue()" class="arrowBtn rightArrow">
                        <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</div>